module.exports = __webpack_public_path__ + "static/img/s7.1982c929.png";